// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// English glosses for the jinmeiyō kanji (see jinmeiyoKanji.js), sourced from
// kanjiapi.dev (https://kanjiapi.dev). Each kanji typically has several
// possible meanings; up to three are listed here.
export const jinmeiyoKanjiMeanings = [
    { symbol: "丑", meaning: "Sign Of The Ox Or Cow, 1-3AM, Second Sign Of Chinese Zodiac" },
    { symbol: "丞", meaning: "Help" },
    { symbol: "乃", meaning: "From, Possessive Particle, Whereupon" },
    { symbol: "之", meaning: "Of, This" },
    { symbol: "乎", meaning: "Question Mark, ?" },
    { symbol: "乘", meaning: "Power, Multiplication, Record" },
    { symbol: "也", meaning: "To Be (Classical)" },
    { symbol: "云", meaning: "Say" },
    { symbol: "亘", meaning: "Span, Range, Extend Over" },
    { symbol: "亙", meaning: "Range, Reach, Extend" },
    { symbol: "些", meaning: "A Little Bit, Sometimes" },
    { symbol: "亞", meaning: "Rank, Follow" },
    { symbol: "亥", meaning: "Sign Of The Hog, 9-11PM, Twelfth Sign Of The Chinese Zodiac" },
    { symbol: "亦", meaning: "Also, Again" },
    { symbol: "亨", meaning: "Pass Through, Go Smoothly" },
    { symbol: "亮", meaning: "Clear, Help" },
    { symbol: "仔", meaning: "Offspring (Animal), Detailed, Fine" },
    { symbol: "伊", meaning: "Italy, That One" },
    { symbol: "伍", meaning: "Five, Five-Man Squad, File" },
    { symbol: "伶", meaning: "Actor" },
    { symbol: "伽", meaning: "Nursing, Attending, Entertainer" },
    { symbol: "佃", meaning: "Cultivated Rice Field" },
    { symbol: "佑", meaning: "Help, Assist" },
    { symbol: "佛", meaning: "France" },
    { symbol: "侃", meaning: "Strong, Just, Righteous" },
    { symbol: "來", meaning: "Come, Due, Next" },
    { symbol: "侑", meaning: "Urge To Eat" },
    { symbol: "俄", meaning: "Sudden, Abrupt, Improvised" },
    { symbol: "俐", meaning: "Clever" },
    { symbol: "俠", meaning: "Chivalrous Person, Chivalry, Knight-Errant" },
    { symbol: "俣", meaning: "Crotch, Thigh, Groin" },
    { symbol: "俱", meaning: "All, Together, Accompany" },
    { symbol: "倖", meaning: "Happiness, Luck" },
    { symbol: "倦", meaning: "Lose Interest In, Tire Of" },
    { symbol: "倭", meaning: "Yamato, Ancient Japan" },
    { symbol: "偲", meaning: "Recollect, Remember" },
    { symbol: "傭", meaning: "Employ, Hire" },
    { symbol: "傳", meaning: "Summon, Propagate, Transmit" },
    { symbol: "僞", meaning: "Lie, Falsehood, Deceive" },
    { symbol: "價", meaning: "Price, Value" },
    { symbol: "儉", meaning: "Economy, Thrifty" },
    { symbol: "儲", meaning: "Be Profitable, Yield Profit" },
    { symbol: "允", meaning: "License, Sincerity, Permit" },
    { symbol: "兎", meaning: "Rabbit, Hare" },
    { symbol: "兒", meaning: "Child, Young Of Animals" },
    { symbol: "兜", meaning: "Helmet, Head Piece" },
    { symbol: "其", meaning: "That" },
    { symbol: "冨", meaning: "Enrich, Wealthy, Abundant" },
    { symbol: "冴", meaning: "Be Clear, Serene, Cold" },
    { symbol: "凉", meaning: "Nice And Cool" },
    { symbol: "凌", meaning: "Endure, Keep (Rain)Out, Stave Off" },
    { symbol: "凛", meaning: "Cold, Strict, Severe" },
    { symbol: "凜", meaning: "Cold, Strict, Severe" },
    { symbol: "凧", meaning: "Kite, (Kokuji)" },
    { symbol: "凪", meaning: "Lull, Calm, (Kokuji)" },
    { symbol: "凰", meaning: "Female Phoenix Bird" },
    { symbol: "凱", meaning: "Victory Song" },
    { symbol: "函", meaning: "Box (Archaic)" },
    { symbol: "剩", meaning: "Leftovers, Residue, Remains" },
    { symbol: "劉", meaning: "Weapon Of War, Logging Axe, Kill En Masse" },
    { symbol: "劍", meaning: "Sword" },
    { symbol: "劫", meaning: "Threat, Long Ages" },
    { symbol: "勁", meaning: "Strong" },
    { symbol: "勳", meaning: "Meritorious Deed, Merits, Rank" },
    { symbol: "勺", meaning: "Ladle, One Tenth Of A Go, Dip" },
    { symbol: "勿", meaning: "Not, Must Not, Do Not" },
    { symbol: "匁", meaning: "Monme, 3.75 Grams, (Kokuji)" },
    { symbol: "匡", meaning: "Correct, Save, Assist" },
    { symbol: "卜", meaning: "Divining, Fortune-Telling, Divination Or Katakana To Radical (No. 25)" },
    { symbol: "卯", meaning: "Sign Of The Hare Or Rabbit, Fourth Sign Of Chinese Zodiac, 5-7AM" },
    { symbol: "卷", meaning: "Volume, Book, Part" },
    { symbol: "卽", meaning: "Promptly, Namely" },
    { symbol: "卿", meaning: "You, Lord, Secretary" },
    { symbol: "厨", meaning: "Kitchen" },
    { symbol: "厩", meaning: "Barn, Stable" },
    { symbol: "叉", meaning: "Fork In Road, Crotch" },
    { symbol: "叡", meaning: "Intelligence, Imperial" },
    { symbol: "叢", meaning: "Plexus, Clump Of Bushes, Thicket" },
    { symbol: "只", meaning: "Only, Free, In Addition" },
    { symbol: "叶", meaning: "Grant, Answer" },
    { symbol: "吞", meaning: "Swallow, Absorb, Annex" },
    { symbol: "吻", meaning: "Proboscis" },
    { symbol: "吾", meaning: "I, My, Our" },
    { symbol: "哉", meaning: "How, What, Alas" },
    { symbol: "哨", meaning: "Scout, Sentinel" },
    { symbol: "哩", meaning: "Mile" },
    { symbol: "啄", meaning: "Peck, Pick Up" },
    { symbol: "喋", meaning: "Talk, Chat, Chatter" },
    { symbol: "喧", meaning: "Noisy, Boisterous" },
    { symbol: "喬", meaning: "High, Boasting" },
    { symbol: "單", meaning: "One, Single, Simple" },
    { symbol: "喰", meaning: "Eat, Drink, Receive (A Blow)" },
    { symbol: "嘉", meaning: "Applaud, Praise, Esteem" },
    { symbol: "嘗", meaning: "Once, Before, Formerly" },
    { symbol: "嘩", meaning: "Noisy" },
    { symbol: "噂", meaning: "Rumor, Gossip, Hearsay" },
    { symbol: "噌", meaning: "Boisterous" },
    { symbol: "嚴", meaning: "Strictness, Severity, Rigidity" },
    { symbol: "圃", meaning: "Garden, Field" },
    { symbol: "圈", meaning: "Sphere, Circle, Radius" },
    { symbol: "國", meaning: "Country" },
    { symbol: "圓", meaning: "Yen, Circle, Round" },
    { symbol: "團", meaning: "Association" },
    { symbol: "圭", meaning: "Square Jewel, Corner, Angle" },
    { symbol: "坐", meaning: "Sit" },
    { symbol: "坦", meaning: "Level, Wide" },
    { symbol: "埜", meaning: "Open Country, Field, Wilderness" },
    { symbol: "埴", meaning: "Clay" },
    { symbol: "堯", meaning: "High, Far" },
    { symbol: "堰", meaning: "Dam, Prevent, Stop Up" },
    { symbol: "堵", meaning: "Fence, Railing, Enclosure" },
    { symbol: "堺", meaning: "World" },
    { symbol: "塙", meaning: "Projecting Tableland Or Mountain" },
    { symbol: "增", meaning: "Increase, Add To, Augment" },
    { symbol: "壕", meaning: "Trench, Dugout, Air Raid Shelter" },
    { symbol: "壘", meaning: "Fort, Rampart, Walls" },
    { symbol: "壞", meaning: "Demolition, Break, Destroy" },
    { symbol: "壬", meaning: "9th Calendar Sign" },
    { symbol: "壯", meaning: "Big, Large, Robust" },
    { symbol: "壽", meaning: "Longevity, Congratulations" },
    { symbol: "夷", meaning: "Barbarian, Savage, Ainu" },
    { symbol: "奄", meaning: "Cover, Suffocate, Obstruct" },
    { symbol: "奎", meaning: "Star, God Of Literature" },
    { symbol: "套", meaning: "Accumulate, Big And Long, Hackneyed" },
    { symbol: "奧", meaning: "Heart, Interior" },
    { symbol: "奬", meaning: "Prize, Reward, Give Award To" },
    { symbol: "姥", meaning: "Old Woman" },
    { symbol: "姪", meaning: "Niece" },
    { symbol: "娃", meaning: "Beautiful" },
    { symbol: "娩", meaning: "Bear (Children)" },
    { symbol: "嬉", meaning: "Glad, Pleased, Rejoice" },
    { symbol: "孃", meaning: "Girl, Miss, Daughter" },
    { symbol: "孜", meaning: "Industriousness" },
    { symbol: "孟", meaning: "Chief, Beginning" },
    { symbol: "宋", meaning: "Dwell, Sung Dynasty" },
    { symbol: "宏", meaning: "Wide, Large" },
    { symbol: "宕", meaning: "Cave" },
    { symbol: "宥", meaning: "Soothe, Calm, Pacify" },
    { symbol: "寅", meaning: "Sign Of The Tiger, 3-5AM, Third Sign Of Chinese Zodiac" },
    { symbol: "寓", meaning: "Temporary Abode, Imply, Suggest" },
    { symbol: "寢", meaning: "Sleep, Rest, Bed Chamber" },
    { symbol: "實", meaning: "Truth, Reality" },
    { symbol: "寬", meaning: "Broad, Wide, Spacious" },
    { symbol: "寵", meaning: "Affection, Love, Patronage" },
    { symbol: "將", meaning: "Commander, General, Admiral" },
    { symbol: "專", meaning: "Specialty, Exclusive, Mainly" },
    { symbol: "尖", meaning: "Be Pointed, Sharp, Taper" },
    { symbol: "尤", meaning: "Reasonable, Just, Natural" },
    { symbol: "尭", meaning: "High, Far" },
    { symbol: "屑", meaning: "Rubbish, Junk, Trash" },
    { symbol: "峨", meaning: "High Mountain" },
    { symbol: "峯", meaning: "Peak, Summit" },
    { symbol: "峻", meaning: "High, Steep" },
    { symbol: "峽", meaning: "Gorge, Strait, Ravine" },
    { symbol: "崚", meaning: "Mountains Towering In A Row" },
    { symbol: "嵩", meaning: "Be Aggravated, Grow Worse, Grow Bulky" },
    { symbol: "嵯", meaning: "Steep, Craggy, Rugged" },
    { symbol: "嶋", meaning: "Island" },
    { symbol: "嶺", meaning: "Peak, Summit" },
    { symbol: "巌", meaning: "Rock, Crag, Boulder" },
    { symbol: "巖", meaning: "Rock, Crag, Boulder" },
    { symbol: "巢", meaning: "Nest, Living Quarter In Tree" },
    { symbol: "巫", meaning: "Sorcerer, Medium, Shrine Maiden" },
    { symbol: "已", meaning: "Stop, Halt, Previously" },
    { symbol: "巳", meaning: "Sign Of The Snake Or Serpent, 9-11AM, Sixth Sign Of Chinese Zodiac" },
    { symbol: "巴", meaning: "Comma-Design" },
    { symbol: "巷", meaning: "Fork In Road, Scene, Arena" },
    { symbol: "巽", meaning: "Southeast" },
    { symbol: "帖", meaning: "Quire (Of Paper), Bundle Of Seaweed, Counter For Screens" },
    { symbol: "帶", meaning: "Belt, Girdle, Band" },
    { symbol: "幌", meaning: "Canopy, Awning, Hood" },
    { symbol: "幡", meaning: "Flag" },
    { symbol: "庄", meaning: "Level, In The Country, Manor" },
    { symbol: "庇", meaning: "Protect, Shield, Defend" },
    { symbol: "庚", meaning: "7th, 7th Calendar Sign" },
    { symbol: "庵", meaning: "Hermitage, Retreat" },
    { symbol: "廟", meaning: "Mausoleum, Shrine, Palace" },
    { symbol: "廣", meaning: "Broad, Wide, Spacious" },
    { symbol: "廳", meaning: "Hall, Central Room" },
    { symbol: "廻", meaning: "Round, Game, Revolve" },
    { symbol: "廿", meaning: "Twenty" },
    { symbol: "弘", meaning: "Vast, Broad, Wide" },
    { symbol: "弛", meaning: "Slacken, Relax" },
    { symbol: "彈", meaning: "Bullet, Twang, Flip" },
    { symbol: "彌", meaning: "Extensive, Full, Fill" },
    { symbol: "彗", meaning: "Comet, Broom" },
    { symbol: "彦", meaning: "Lad, Boy (Ancient)" },
    { symbol: "彪", meaning: "Spotted, Mottled, Patterned" },
    { symbol: "彬", meaning: "Refined, Gentle" },
    { symbol: "從", meaning: "From, By, Since" },
    { symbol: "徠", meaning: "Induce, Encourage To Come" },
    { symbol: "徵", meaning: "Summon, Recruit, Musical Note" },
    { symbol: "德", meaning: "Ethics, Morality, Virtue" },
    { symbol: "徽", meaning: "Good, Beautiful, Badge" },
    { symbol: "忽", meaning: "In A Moment, Instantly, All Of A Sudden" },
    { symbol: "怜", meaning: "Wise" },
    { symbol: "恆", meaning: "Constant, Regular, Persistent" },
    { symbol: "恕", meaning: "Excuse, Tolerate, Forgive" },
    { symbol: "恢", meaning: "Wide, Large, Enlarge" },
    { symbol: "恰", meaning: "Just As, As Though, Fortunately" },
    { symbol: "悉", meaning: "All, Entirely, Altogether" },
    { symbol: "悌", meaning: "Serving Our Elders" },
    { symbol: "惇", meaning: "Sincere, Kind, Considerate" },
    { symbol: "惚", meaning: "Fall In Love With, Admire, Grow Senile" },
    { symbol: "惟", meaning: "Consider, Reflect, Think" },
    { symbol: "惠", meaning: "Blessing, Grace, Favor" },
    { symbol: "惡", meaning: "Bad, Evil" },
    { symbol: "惣", meaning: "All" },
    { symbol: "惹", meaning: "Attract, Captivate" },
    { symbol: "惺", meaning: "Realize" },
    { symbol: "愼", meaning: "Care, Chastity" },
    { symbol: "慧", meaning: "Wise" },
    { symbol: "憐", meaning: "Pity, Have Mercy, Sympathise" },
    { symbol: "應", meaning: "Answer, Yes, OK" },
    { symbol: "懷", meaning: "Pocket, Feelings, Heart" },
    { symbol: "戊", meaning: "5th Calendar Sign" },
    { symbol: "或", meaning: "Some, One, Or" },
    { symbol: "戟", meaning: "Halbert, Arms" },
    { symbol: "戰", meaning: "War, Fighting, Battle" },
    { symbol: "戲", meaning: "Play, Frolic, Sport" },
    { symbol: "托", meaning: "Requesting, Entrusting With, Pretend" },
    { symbol: "拂", meaning: "Clear Out, Sweep Away" },
    { symbol: "拔", meaning: "Extract, Pull Out, Pilfer" },
    { symbol: "拜", meaning: "Worship, Adore, Pray To" },
    { symbol: "按", meaning: "Hold, Consider, Investigate" },
    { symbol: "挺", meaning: "Bravely Volunteer, Counter For Guns, Inksticks, Palanquins, Rickshaws" },
    { symbol: "挽", meaning: "Saw, Turn (Lathe), Grind" },
    { symbol: "捧", meaning: "Lift Up, Give, Offer" },
    { symbol: "捲", meaning: "Roll, Wind, Coil" },
    { symbol: "捷", meaning: "Victory, Fast" },
    { symbol: "捺", meaning: "Press, Print, Affix A Seal" },
    { symbol: "掠", meaning: "Pillage, Rob, Graze" },
    { symbol: "掬", meaning: "Scoop Up Water With The Hand" },
    { symbol: "揃", meaning: "Be Complete, Uniform, All Present" },
    { symbol: "揭", meaning: "Raise, Lift Up, Surname" },
    { symbol: "搖", meaning: "Wag, Swing, Wave" },
    { symbol: "搜", meaning: "Search, Seek, Investigate" },
    { symbol: "摑", meaning: "Box One'S Ears, Slap" },
    { symbol: "摺", meaning: "Rub, Fold, Print (On Cloth)" },
    { symbol: "撒", meaning: "Scatter, Sprinkle, Give Them The Slip" },
    { symbol: "撞", meaning: "Thrust, Pierce, Stab" },
    { symbol: "撫", meaning: "Stroke, Pat, Smooth Down" },
    { symbol: "播", meaning: "Plant, Sow" },
    { symbol: "撰", meaning: "Composing, Editing, Compiling" },
    { symbol: "擊", meaning: "Strike, Hit, Beat" },
    { symbol: "擢", meaning: "Excel In, Surpass, Pull Out" },
    { symbol: "攝", meaning: "Surrogate, Act In Addition To" },
    { symbol: "收", meaning: "Income" },
    { symbol: "敍", meaning: "Express, State, Relate" },
    { symbol: "敦", meaning: "Industry, Kindliness" },
    { symbol: "斐", meaning: "Beautiful, Patterned" },
    { symbol: "斡", meaning: "Go Around, Rule, Administer" },
    { symbol: "斧", meaning: "Ax, Hatchet" },
    { symbol: "斯", meaning: "This, Thus, Such" },
    { symbol: "於", meaning: "At, In, On" },
    { symbol: "旭", meaning: "Rising Sun, Morning Sun" },
    { symbol: "昂", meaning: "Rise" },
    { symbol: "昊", meaning: "Sky, Big" },
    { symbol: "昌", meaning: "Prosperous, Bright, Clear" },
    { symbol: "昏", meaning: "Dark, Evening, Dusk" },
    { symbol: "昴", meaning: "The Pleiades" },
    { symbol: "晃", meaning: "Clear" },
    { symbol: "晄", meaning: "Clear" },
    { symbol: "晋", meaning: "Advance" },
    { symbol: "晏", meaning: "Late, Quiet, Sets (Sun)" },
    { symbol: "晒", meaning: "Bleach, Refine, Expose" },
    { symbol: "晚", meaning: "Night, Evening, Late" },
    { symbol: "晝", meaning: "Daytime, Daylight" },
    { symbol: "晟", meaning: "Clear" },
    { symbol: "晦", meaning: "Dark, Disappear" },
    { symbol: "晨", meaning: "Morning, Early" },
    { symbol: "智", meaning: "Wisdom, Intellect, Reason" },
    { symbol: "暉", meaning: "Shine, Light" },
    { symbol: "暢", meaning: "Stretch" },
    { symbol: "曆", meaning: "Calendar, Era" },
    { symbol: "曉", meaning: "Dawn, Daybreak, Clear" },
    { symbol: "曙", meaning: "Dawn, Daybreak" },
    { symbol: "曝", meaning: "Bleach, Refine, Expose" },
    { symbol: "曳", meaning: "Pull, Tug, Jerk" },
    { symbol: "曾", meaning: "Once, Before, Formerly" },
    { symbol: "朋", meaning: "Companion, Friend" },
    { symbol: "朔", meaning: "Conjunction (Astronomy), First Day Of Month, North" },
    { symbol: "李", meaning: "Plum" },
    { symbol: "杏", meaning: "Apricot" },
    { symbol: "杖", meaning: "Staff, Cane" },
    { symbol: "杜", meaning: "Woods, Grove" },
    { symbol: "杭", meaning: "Stake, Post, Picket" },
    { symbol: "杵", meaning: "Wooden Pestle" },
    { symbol: "杷", meaning: "Kind Of Rake, Loquat" },
    { symbol: "枇", meaning: "Loquat, Spoon" },
    { symbol: "柊", meaning: "Holly" },
    { symbol: "柏", meaning: "Oak, Cypress" },
    { symbol: "柑", meaning: "Citrus, Orange" },
    { symbol: "柘", meaning: "Wild Mulberry" },
    { symbol: "柚", meaning: "Citron" },
    { symbol: "柴", meaning: "Brush, Firewood" },
    { symbol: "柾", meaning: "Straight Grain, Spindle Tree, (Kokuji)" },
    { symbol: "栖", meaning: "Nest, Rookery, Hive" },
    { symbol: "栗", meaning: "Chestnut" },
    { symbol: "栞", meaning: "Bookmark, Guidebook" },
    { symbol: "桂", meaning: "Japanese Judas-Tree, Cinnamon Tree" },
    { symbol: "桐", meaning: "Paulownia" },
    { symbol: "桔", meaning: "Used In Plant Names" },
    { symbol: "桧", meaning: "Japanese Cypress" },
    { symbol: "桶", meaning: "Tub, Bucket" },
    { symbol: "梁", meaning: "Weir, Fish Trap, Beam" },
    { symbol: "梓", meaning: "Catalpa Tree, Woodblock Printing" },
    { symbol: "梛", meaning: "Type Of Tall Evergreen Tree" },
    { symbol: "條", meaning: "Article, Counter For Articles, Clauses, Paragraphs, Etc., Twig" },
    { symbol: "梢", meaning: "Treetops, Twig" },
    { symbol: "梧", meaning: "Chinese Parasol Tree, Phoenix Tree" },
    { symbol: "梯", meaning: "Ladder, Stairs, Insatiable Drinking" },
    { symbol: "梶", meaning: "Sculling Oar" },
    { symbol: "棲", meaning: "Live, Dwell" },
    { symbol: "椀", meaning: "Wooden Or Lacquered Bowl" },
    { symbol: "椋", meaning: "Type Of Deciduous Tree, Grey Starling" },
    { symbol: "椛", meaning: "Autumn Foliage, Birch, Maple" },
    { symbol: "椰", meaning: "Coconut Tree" },
    { symbol: "椿", meaning: "Camellia" },
    { symbol: "楊", meaning: "Willow" },
    { symbol: "楓", meaning: "Maple" },
    { symbol: "楕", meaning: "Ellipse" },
    { symbol: "楚", meaning: "Whip, Cane" },
    { symbol: "楠", meaning: "Camphor Tree" },
    { symbol: "楢", meaning: "Oak" },
    { symbol: "楯", meaning: "Shield, Buckler, Pretext" },
    { symbol: "榊", meaning: "Sacred Shinto Tree, (Kokuji)" },
    { symbol: "榎", meaning: "Lotus Tree, Nettle Tree, Hackberry" },
    { symbol: "榛", meaning: "Hazelnut, Filbert" },
    { symbol: "榮", meaning: "Flourish, Prosperity, Honour" },
    { symbol: "槇", meaning: "Twig, Chinese Black Pine" },
    { symbol: "槌", meaning: "Hammer, Mallet" },
    { symbol: "槍", meaning: "Spear, Lance, Javelin" },
    { symbol: "槙", meaning: "Twig, Ornamental Evergreen" },
    { symbol: "槻", meaning: "Zelkova Tree" },
    { symbol: "樂", meaning: "Music, Comfort" },
    { symbol: "樋", meaning: "Water Pipe, Gutter, Downspout" },
    { symbol: "樟", meaning: "Camphor" },
    { symbol: "樣", meaning: "Esq., Way, Manner" },
    { symbol: "樫", meaning: "Evergreen Oak, (Kokuji)" },
    { symbol: "樺", meaning: "Birch, Dark Red" },
    { symbol: "樽", meaning: "Barrel, Cask, Keg" },
    { symbol: "橘", meaning: "Mandarin Orange" },
    { symbol: "橙", meaning: "Bitter Orange" },
    { symbol: "橫", meaning: "Across, Horizontal, Lateral" },
    { symbol: "檀", meaning: "Cedar, Sandalwood, Spindle Tree" },
    { symbol: "檎", meaning: "Apple" },
    { symbol: "檜", meaning: "Japanese Cypress" },
    { symbol: "檢", meaning: "Check, Examine" },
    { symbol: "櫂", meaning: "Oar, Scull, Paddle" },
    { symbol: "櫓", meaning: "Oar, Tower" },
    { symbol: "櫛", meaning: "Comb" },
    { symbol: "櫻", meaning: "Cherry" },
    { symbol: "欣", meaning: "Take Pleasure In, Rejoice" },
    { symbol: "欽", meaning: "Respect, Revere, Long For" },
    { symbol: "歎", meaning: "Grief, Lamentation" },
    { symbol: "此", meaning: "This, Current, Next" },
    { symbol: "步", meaning: "Step, Pace, Walk" },
    { symbol: "歷", meaning: "Take Place, Past, History" },
    { symbol: "殆", meaning: "Almost, Quite, Really" },
    { symbol: "毅", meaning: "Strong" },
    { symbol: "每", meaning: "Every, Each" },
    { symbol: "毘", meaning: "Help, Assist" },
    { symbol: "毬", meaning: "Burr, Ball" },
    { symbol: "氣", meaning: "Spirit, Mind, Air" },
    { symbol: "汀", meaning: "Water'S Edge, Shore, Bank" },
    { symbol: "汐", meaning: "Eventide, Tide, Salt Water" },
    { symbol: "汝", meaning: "You, Thou" },
    { symbol: "汲", meaning: "Draw (Water), Ladle, Scoop" },
    { symbol: "沌", meaning: "Primeval Chaos" },
    { symbol: "沓", meaning: "Shoes, Boots" },
    { symbol: "沫", meaning: "Splash, Suds" },
    { symbol: "洛", meaning: "Kyoto, The Capital" },
    { symbol: "洲", meaning: "Continent, Sandbar, Island" },
    { symbol: "洵", meaning: "Alike, Truth" },
    { symbol: "洸", meaning: "Sparkling Water" },
    { symbol: "浩", meaning: "Wide Expanse, Abundance, Vigorous" },
    { symbol: "浬", meaning: "Knot, Nautical Mile" },
    { symbol: "涉", meaning: "Ford Stream, Wade Across" },
    { symbol: "淀", meaning: "Pool, Eddy" },
    { symbol: "淋", meaning: "Lonely, Deserted" },
    { symbol: "淚", meaning: "Tears, Weep, Cry" },
    { symbol: "淨", meaning: "Pure, Clean, Unspoiled" },
    { symbol: "淳", meaning: "Pure" },
    { symbol: "淵", meaning: "Abyss, Edge, Deep Pool" },
    { symbol: "渚", meaning: "Strand, Beach, Shore" },
    { symbol: "渥", meaning: "Kindness, Moisten" },
    { symbol: "渴", meaning: "Thirsty, Parched, Yearn" },
    { symbol: "渾", meaning: "All, Turbidity" },
    { symbol: "湊", meaning: "Port, Harbor" },
    { symbol: "湘", meaning: "Name Of Chinese River, The Sagami River" },
    { symbol: "湛", meaning: "Fill, Wear (A Smile), Clear" },
    { symbol: "溜", meaning: "Collect, Gather, Be In Arrears" },
    { symbol: "溢", meaning: "Overflow, Inundate, Spill" },
    { symbol: "溫", meaning: "Lukewarm, Warm, Tepid" },
    { symbol: "滉", meaning: "Deep And Broad (Water)" },
    { symbol: "滯", meaning: "Block Up, Obstruct, Stagnant" },
    { symbol: "漕", meaning: "Rowing, Scull, Paddle" },
    { symbol: "漣", meaning: "Ripples" },
    { symbol: "漱", meaning: "Gargle, Rinse Mouth" },
    { symbol: "澁", meaning: "Astringent, Harsh, Uneven" },
    { symbol: "澪", meaning: "Water Route, Shipping Channel" },
    { symbol: "濕", meaning: "Wet, Moist, Humid" },
    { symbol: "濡", meaning: "Get Wet, Damp, Make Love" },
    { symbol: "瀕", meaning: "Shore, Brink, Verge" },
    { symbol: "瀧", meaning: "Waterfall, Rapids, Cascade" },
    { symbol: "瀨", meaning: "Swift Current, Rapids" },
    { symbol: "灘", meaning: "Open Sea" },
    { symbol: "灸", meaning: "Moxa Cautery, Chastisement" },
    { symbol: "灼", meaning: "Miraculous" },
    { symbol: "烏", meaning: "Crow, Raven" },
    { symbol: "焚", meaning: "Burn, Kindle, Build A Fire" },
    { symbol: "焰", meaning: "Flame, Blaze, Glowing" },
    { symbol: "煉", meaning: "Refine Metals, Kneading Over Fire" },
    { symbol: "煌", meaning: "Glitter, Gleam, Twinkle" },
    { symbol: "煤", meaning: "Soot, Smoke Dried" },
    { symbol: "熙", meaning: "Bright, Sunny, Prosperous" },
    { symbol: "燈", meaning: "Lamp, Light, Counter For Lights" },
    { symbol: "燎", meaning: "Burn, Bonfire" },
    { symbol: "燒", meaning: "Burn, Bake, Heat" },
    { symbol: "燕", meaning: "Swallow (Bird)" },
    { symbol: "燦", meaning: "Brilliant" },
    { symbol: "燭", meaning: "Light, Candlepower" },
    { symbol: "燿", meaning: "Shine" },
    { symbol: "爭", meaning: "To Dispute, Fight, Contend" },
    { symbol: "爲", meaning: "Change, Be Of Use, Reach To" },
    { symbol: "爾", meaning: "You, Thou, Second Person" },
    { symbol: "牒", meaning: "Label, Genealogy, Circular" },
    { symbol: "牟", meaning: "Pupil (Eye), Moo (Cow Sound)" },
    { symbol: "牡", meaning: "Male" },
    { symbol: "牽", meaning: "Pull, Tug, Drag" },
    { symbol: "犀", meaning: "Rhinoceros" },
    { symbol: "狀", meaning: "Form, Appearance, Shape" },
    { symbol: "狹", meaning: "Narrow, Contract, Reduce" },
    { symbol: "狼", meaning: "Wolf" },
    { symbol: "猪", meaning: "Boar" },
    { symbol: "獅", meaning: "Lion" },
    { symbol: "獸", meaning: "Beast, Animal, Bestial" },
    { symbol: "玖", meaning: "Beautiful Black Jewel, Nine" },
    { symbol: "玲", meaning: "Sound Of Jewels" },
    { symbol: "珀", meaning: "Amber" },
    { symbol: "珂", meaning: "Jewel" },
    { symbol: "珈", meaning: "Ornamental Hairpin" },
    { symbol: "珊", meaning: "Coral, Centimeter" },
    { symbol: "琉", meaning: "Precious Stone, Gem, Lapis Lazuli" },
    { symbol: "琢", meaning: "Polish" },
    { symbol: "琥", meaning: "Jewelled Utensil" },
    { symbol: "琳", meaning: "Jewel, Tinkling Of Jewelry" },
    { symbol: "琵", meaning: "Glissando On Strings, Lute" },
    { symbol: "琶", meaning: "Lute" },
    { symbol: "瑚", meaning: "Ancestral Offering Receptacle, Coral" },
    { symbol: "瑛", meaning: "Sparkle Of Jewelry, Crystal" },
    { symbol: "瑞", meaning: "Congratulations" },
    { symbol: "瑳", meaning: "Polish, Brilliant White Luster Of A Gem, Artful Smile" },
    { symbol: "瑶", meaning: "Beautiful As A Jewel" },
    { symbol: "瓜", meaning: "Melon" },
    { symbol: "瓢", meaning: "Gourd" },
    { symbol: "甥", meaning: "Nephew" },
    { symbol: "甫", meaning: "For The First Time, Not Until" },
    { symbol: "畠", meaning: "Field, Farm, Garden" },
    { symbol: "畢", meaning: "The End, Finish" },
    { symbol: "疊", meaning: "Tatami, Counter For Tatami Mats, Fold" },
    { symbol: "疋", meaning: "Head, Counter For Animals" },
    { symbol: "疏", meaning: "Pass Through, Note, Commentary" },
    { symbol: "瘦", meaning: "Thin, Emaciated, Lean" },
    { symbol: "皐", meaning: "Swamp, Shore, Fifth Month" },
    { symbol: "皓", meaning: "White, Clear" },
    { symbol: "盃", meaning: "Glass, Cup" },
    { symbol: "盜", meaning: "Thief, To Steal" },
    { symbol: "盡", meaning: "Exhaust, Use Up, Run Out Of" },
    { symbol: "眞", meaning: "Truth, Reality, Buddhist Sect" },
    { symbol: "眸", meaning: "Pupil Of The Eye" },
    { symbol: "瞥", meaning: "Glance At" },
    { symbol: "矩", meaning: "Ruler, Carpenter'S Square" },
    { symbol: "砥", meaning: "Whetstone, Grindstone" },
    { symbol: "砦", meaning: "Fort, Stronghold, Entrenchments" },
    { symbol: "砧", meaning: "Fulling Block" },
    { symbol: "硯", meaning: "Inkstone" },
    { symbol: "碎", meaning: "Break, Smash, Broken" },
    { symbol: "碓", meaning: "Pestle" },
    { symbol: "碗", meaning: "Porcelain Bowl, Tea Cup" },
    { symbol: "碧", meaning: "Blue, Green" },
    { symbol: "碩", meaning: "Large, Great, Eminent" },
    { symbol: "磐", meaning: "Rock, Crag, Cliff" },
    { symbol: "磯", meaning: "Seashore, Beach" },
    { symbol: "祁", meaning: "Intense, Large" },
    { symbol: "祇", meaning: "National Or Local God, Peaceful, Great" },
    { symbol: "祐", meaning: "Help" },
    { symbol: "祕", meaning: "Mysterious, Secret, Abstruse" },
    { symbol: "祢", meaning: "Ancestral Shrine" },
    { symbol: "祷", meaning: "Pray" },
    { symbol: "祿", meaning: "Fief, Allowance, Pension" },
    { symbol: "禄", meaning: "Fief, Allowance, Pension" },
    { symbol: "禎", meaning: "Happiness, Blessed, Good Fortune" },
    { symbol: "禪", meaning: "Zen Buddhism, Silent Meditation" },
    { symbol: "禮", meaning: "Social Custom, Manners, Courtesy" },
    { symbol: "禰", meaning: "Ancestral Shrine" },
    { symbol: "禱", meaning: "Pray, Entreat, Beg" },
    { symbol: "禽", meaning: "Bird, Captive, Capture" },
    { symbol: "禾", meaning: "Two-Branch Tree Radical (No. 115)" },
    { symbol: "秤", meaning: "Balances, Scales, Steelyard" },
    { symbol: "秦", meaning: "Manchu Dynasty, Name Given To Naturalized Foreigners" },
    { symbol: "稀", meaning: "Rare, Phenomenal, Dilute (Acid)" },
    { symbol: "稔", meaning: "Harvest, Ripen" },
    { symbol: "稜", meaning: "Angle, Edge, Corner" },
    { symbol: "稟", meaning: "Salary In Rice" },
    { symbol: "稻", meaning: "Rice Plant" },
    { symbol: "穗", meaning: "Ear (Of Grain), Head, Crest (Of Wave)" },
    { symbol: "穣", meaning: "Good Crops, Prosperity, 10**28" },
    { symbol: "穰", meaning: "Abundance" },
    { symbol: "穹", meaning: "Sky" },
    { symbol: "穿", meaning: "Put On (To The Feet), Dig, Pierce" },
    { symbol: "窄", meaning: "Narrow, Fold, Furl" },
    { symbol: "窪", meaning: "Depression, Cave In, Sink" },
    { symbol: "窺", meaning: "Lie In Wait, Spy On, Reconnoiter" },
    { symbol: "竣", meaning: "End, Finish" },
    { symbol: "竪", meaning: "Length, Height, Warp" },
    { symbol: "竺", meaning: "Bamboo" },
    { symbol: "竿", meaning: "Pole, Rod, Scale Beam" },
    { symbol: "笈", meaning: "Backpack Bookcase" },
    { symbol: "笙", meaning: "A Reed Instrument" },
    { symbol: "笠", meaning: "Bamboo Hat, One'S Influence" },
    { symbol: "笹", meaning: "Bamboo Grass, (Kokuji)" },
    { symbol: "筈", meaning: "Notch Of An Arrow, Ought, Must" },
    { symbol: "筑", meaning: "An Ancient Musical Instrument" },
    { symbol: "箔", meaning: "Foil, Gilt" },
    { symbol: "箕", meaning: "Winnowing" },
    { symbol: "篇", meaning: "Volume, Chapter, Book" },
    { symbol: "篠", meaning: "Bamboo Grass" },
    { symbol: "簞", meaning: "Small Bamboo Basket For Holding" },
    { symbol: "簾", meaning: "Bamboo Screen, Rattan Blind" },
    { symbol: "籾", meaning: "Unhulled Rice, (Kokuji)" },
    { symbol: "粟", meaning: "Millet" },
    { symbol: "粥", meaning: "Rice Gruel" },
    { symbol: "粹", meaning: "Pure, Unadulterated, Select" },
    { symbol: "糊", meaning: "Paste, Glue, Sizing" },
    { symbol: "紐", meaning: "String, Cord, Braid" },
    { symbol: "紗", meaning: "Gauze, Gossamer" },
    { symbol: "紘", meaning: "Large" },
    { symbol: "紬", meaning: "Pongee (A Knotted Silk Cloth)" },
    { symbol: "絃", meaning: "String, Cord, Samisen Music" },
    { symbol: "絆", meaning: "Bonds, Fetters" },
    { symbol: "絢", meaning: "Brilliant Fabric Design" },
    { symbol: "綜", meaning: "Rule, Synthesize" },
    { symbol: "綠", meaning: "Green, Chlorine" },
    { symbol: "綴", meaning: "Compose, Spell, Write" },
    { symbol: "綸", meaning: "Thread, Silk Cloth" },
    { symbol: "綺", meaning: "Figured Cloth, Beautiful" },
    { symbol: "綾", meaning: "Design, Figured Cloth, Twill" },
    { symbol: "緋", meaning: "Scarlet, Cardinal" },
    { symbol: "緖", meaning: "End Of Thread, Thread, Clue" },
    { symbol: "緣", meaning: "Hem, Margin, Reason" },
    { symbol: "縞", meaning: "Stripe" },
    { symbol: "縣", meaning: "County, District, Subdivision" },
    { symbol: "縱", meaning: "Indulge In, Give Free Reign To" },
    { symbol: "繡", meaning: "Embroider, Embroidery, Ornament" },
    { symbol: "繫", meaning: "Attach, Connect, Unite" },
    { symbol: "纂", meaning: "Editing, Compiling" },
    { symbol: "纏", meaning: "Wear, Wrap, Tie" },
    { symbol: "纖", meaning: "Fine, Slender, Thin Kimono" },
    { symbol: "羚", meaning: "Antelope" },
    { symbol: "翔", meaning: "Soar, Fly" },
    { symbol: "翠", meaning: "Green, Kingfisher" },
    { symbol: "耀", meaning: "Shine, Sparkle, Gleam" },
    { symbol: "而", meaning: "And Yet, And Then, But" },
    { symbol: "耶", meaning: "Question Mark" },
    { symbol: "耽", meaning: "Addicted, Absorbed In" },
    { symbol: "聡", meaning: "Wise, Fast Learner" },
    { symbol: "聽", meaning: "Careful Enquiry, Headstrong" },
    { symbol: "肇", meaning: "Beginning" },
    { symbol: "肋", meaning: "Rib" },
    { symbol: "肴", meaning: "Accompaniment For Drinks" },
    { symbol: "胡", meaning: "Barbarian, Foreign" },
    { symbol: "胤", meaning: "Descendent, Issue, Offspring" },
    { symbol: "脩", meaning: "Dried Meat" },
    { symbol: "脹", meaning: "Dilate, Distend, Bulge" },
    { symbol: "腔", meaning: "Body Cavity" },
    { symbol: "膏", meaning: "Fat, Grease, Lard" },
    { symbol: "臟", meaning: "Viscera, Bowels" },
    { symbol: "臥", meaning: "Bend Down, Bow, Lie Prostrate" },
    { symbol: "與", meaning: "Participate In, Give, Award" },
    { symbol: "舜", meaning: "Type Of Morning Glory, Rose Of Sharon, Althea" },
    { symbol: "舵", meaning: "Rudder, Helm, Wheel" },
    { symbol: "芙", meaning: "Lotus, Mt Fuji" },
    { symbol: "芥", meaning: "Mustard, Rape, Dust" },
    { symbol: "芦", meaning: "Reed, Bullrush" },
    { symbol: "芭", meaning: "Banana" },
    { symbol: "芹", meaning: "Parsley" },
    { symbol: "苑", meaning: "Garden, Farm, Park" },
    { symbol: "苔", meaning: "Moss, Lichen" },
    { symbol: "苺", meaning: "Strawberry" },
    { symbol: "茄", meaning: "Eggplant" },
    { symbol: "茅", meaning: "Miscanthus Reed" },
    { symbol: "茉", meaning: "Jasmine" },
    { symbol: "茜", meaning: "Madder, Red Dye, Turkey Red" },
    { symbol: "茸", meaning: "Mushroom" },
    { symbol: "荻", meaning: "Reed, Rush" },
    { symbol: "莉", meaning: "Jasmine" },
    { symbol: "莊", meaning: "Broom" },
    { symbol: "莞", meaning: "Smiling, Reed Used To Cover Tatami" },
    { symbol: "莫", meaning: "Must Not, Do Not, Be Not" },
    { symbol: "菅", meaning: "Sedge" },
    { symbol: "菖", meaning: "Iris" },
    { symbol: "菩", meaning: "Kind Of Grass, Sacred Tree" },
    { symbol: "菫", meaning: "The Violet" },
    { symbol: "菱", meaning: "Diamond (Shape), Water Chestnut, Rhombus" },
    { symbol: "萄", meaning: "Grape Vine, Wild Grape" },
    { symbol: "萊", meaning: "Goosefoot, Weed, Fallow Field" },
    { symbol: "萌", meaning: "Show Symptoms Of, Sprout, Bud" },
    { symbol: "萠", meaning: "Show Symptoms Of, Sprout, Bud" },
    { symbol: "萩", meaning: "Bush Clover" },
    { symbol: "萬", meaning: "Ten Thousand, 10,000" },
    { symbol: "萱", meaning: "Miscanthus Reed" },
    { symbol: "葡", meaning: "Wild Grape, Portugal" },
    { symbol: "董", meaning: "Correct" },
    { symbol: "葦", meaning: "Reed, Bullrush" },
    { symbol: "葵", meaning: "Hollyhock" },
    { symbol: "葺", meaning: "Thatch, Cover, Shingle" },
    { symbol: "蒐", meaning: "Gather" },
    { symbol: "蒔", meaning: "Sow (Seeds)" },
    { symbol: "蒙", meaning: "Ignorance, Darkness, Get" },
    { symbol: "蒲", meaning: "Bullrush, Flag, Cattail" },
    { symbol: "蒼", meaning: "Blue, Pale" },
    { symbol: "蓉", meaning: "Lotus" },
    { symbol: "蓑", meaning: "Straw Raincoat" },
    { symbol: "蓬", meaning: "Sagebrush, Wormwood, Mugwort" },
    { symbol: "蓮", meaning: "Lotus" },
    { symbol: "蔓", meaning: "Vine, Tendril, Influence" },
    { symbol: "蔣", meaning: "Surname, Hydropyrum Latifalium" },
    { symbol: "蔦", meaning: "Vine, Ivy" },
    { symbol: "蔭", meaning: "Shade, Shadow, Backing Assistance" },
    { symbol: "蕃", meaning: "Grow Luxuriously" },
    { symbol: "蕉", meaning: "Banana, Plantain" },
    { symbol: "蕎", meaning: "Buckwheat" },
    { symbol: "蕗", meaning: "Butterbur, Bog Rhubarb" },
    { symbol: "蕨", meaning: "Bracken, Fernbrake" },
    { symbol: "蕪", meaning: "Turnip" },
    { symbol: "蕾", meaning: "Bud (Plants, Mushrooms Not Yet Opened)" },
    { symbol: "薗", meaning: "Garden, Yard, Farm" },
    { symbol: "薙", meaning: "Mow Down (The Enemy)" },
    { symbol: "薩", meaning: "Salvation, Buddha" },
    { symbol: "薰", meaning: "A Medicinal Herb, To Cauterize" },
    { symbol: "藁", meaning: "Straw" },
    { symbol: "藏", meaning: "Hide, Own, Have" },
    { symbol: "藝", meaning: "Art, Craft, Performance" },
    { symbol: "藥", meaning: "Medicine, Chemical, Enamel" },
    { symbol: "蘇", meaning: "Be Resuscitated, Revived, Perilla" },
    { symbol: "蘭", meaning: "Orchid, Holland" },
    { symbol: "虛", meaning: "False, Worthless, Empty" },
    { symbol: "蝦", meaning: "Shrimp, Prawn, Lobster" },
    { symbol: "蝶", meaning: "Butterfly" },
    { symbol: "螺", meaning: "Small, Edible, Helical Fresh-Water Mollusk" },
    { symbol: "蟬", meaning: "Cicada, Continuous" },
    { symbol: "蟹", meaning: "Crab" },
    { symbol: "蠟", meaning: "Wax, Candle, Waxy" },
    { symbol: "衞", meaning: "Defense" },
    { symbol: "衿", meaning: "Neck, Collar, Lapel" },
    { symbol: "袈", meaning: "A Coarse Camlet" },
    { symbol: "袴", meaning: "Men'S Formal Divided Skirt" },
    { symbol: "裝", meaning: "Dress, Pretend, Disguise" },
    { symbol: "裟", meaning: "Buddhist Surplice" },
    { symbol: "裡", meaning: "Reverse, Inside, Palm" },
    { symbol: "裳", meaning: "Skirt" },
    { symbol: "襖", meaning: "Opaque Sliding Door" },
    { symbol: "覽", meaning: "Look At, Inspect, Perceive" },
    { symbol: "訊", meaning: "Request, Question, Investigate" },
    { symbol: "訣", meaning: "Separation, Part, Secret" },
    { symbol: "註", meaning: "Notes, Comment, Annotate" },
    { symbol: "詢", meaning: "Consult With" },
    { symbol: "詫", meaning: "Apologize" },
    { symbol: "誼", meaning: "Friendship, Intimacy" },
    { symbol: "諄", meaning: "Tedious" },
    { symbol: "諏", meaning: "Consult" },
    { symbol: "諒", meaning: "Fact, Reality, Understand" },
    { symbol: "諺", meaning: "Proverb" },
    { symbol: "謂", meaning: "Reason, Origin, History" },
    { symbol: "謠", meaning: "Chant (Esp. Noh), Folksong, Ballad" },
    { symbol: "讃", meaning: "Praise, Title On A Picture" },
    { symbol: "讓", meaning: "Allow, Permit, Yield" },
    { symbol: "豹", meaning: "Leopard, Panther" },
    { symbol: "貰", meaning: "Get, Have, Obtain" },
    { symbol: "賑", meaning: "Flourish, Be Bustling, Prosperity" },
    { symbol: "賣", meaning: "Sell, Betray, Show Off" },
    { symbol: "賴", meaning: "Rely, Depend On, Accuse Falsely" },
    { symbol: "赳", meaning: "Strong And Brave" },
    { symbol: "跨", meaning: "Be, Sit Or Stand Astride, Extend Over" },
    { symbol: "蹄", meaning: "Hoof" },
    { symbol: "蹟", meaning: "Remains, Traces, Footprint" },
    { symbol: "輔", meaning: "Help" },
    { symbol: "輯", meaning: "Gather, Collect, Compile" },
    { symbol: "輿", meaning: "Palanquin, Bier, Public Opinion" },
    { symbol: "轉", meaning: "Shift, Move, Turn" },
    { symbol: "轟", meaning: "Roar, Thunder, Boom Resound" },
    { symbol: "辰", meaning: "Sign Of The Dragon, 7-9AM, Fifth Sign Of Chinese Zodiac" },
    { symbol: "辻", meaning: "Crossing, Crossroad, Street Corners" },
    { symbol: "辿", meaning: "Follow (Road), Pursue" },
    { symbol: "迂", meaning: "Roundabout Way" },
    { symbol: "迄", meaning: "Until, Up To, As Far As" },
    { symbol: "迦", meaning: "(Used Phonetically)" },
    { symbol: "迪", meaning: "Edify, Way, Path" },
    { symbol: "逗", meaning: "Stop" },
    { symbol: "這", meaning: "Crawl, Creep, Grovel" },
    { symbol: "逞", meaning: "Sturdy, Brawny, Bold" },
    { symbol: "逢", meaning: "Meeting, Tryst, Date" },
    { symbol: "遁", meaning: "Flee, Escape, Shirk" },
    { symbol: "遙", meaning: "Far Off, Distant, Long Ago" },
    { symbol: "遥", meaning: "Far Off, Distant, Long Ago" },
    { symbol: "遼", meaning: "Distant" },
    { symbol: "邑", meaning: "Village, Rural Community, Right Village Radical (No. 163)" },
    { symbol: "郁", meaning: "Cultural Progress, Perfume" },
    { symbol: "郞", meaning: "Gentleman" },
    { symbol: "鄭", meaning: "An Ancient Chinese Province" },
    { symbol: "酉", meaning: "West, Bird, Sign Of The Bird" },
    { symbol: "醇", meaning: "Pure Sake, Purity, Affection" },
    { symbol: "醉", meaning: "Get Drunk, Feel Sick, Poisoned" },
    { symbol: "醍", meaning: "Whey, Good Buddhist Teaching" },
    { symbol: "醐", meaning: "Boiled Butter" },
    { symbol: "醬", meaning: "Any Jam-Like Or Paste-Like Food" },
    { symbol: "釀", meaning: "Brew, Cause" },
    { symbol: "釉", meaning: "Glaze, Enamel" },
    { symbol: "釘", meaning: "Nail, Tack, Peg" },
    { symbol: "釧", meaning: "Bracelet" },
    { symbol: "銑", meaning: "Pig Iron" },
    { symbol: "鋒", meaning: "Dagger, Sword'S Point, Festival Car" },
    { symbol: "鋸", meaning: "Saw (Cuts Wood)" },
    { symbol: "錄", meaning: "Copy, Write Down, Record" },
    { symbol: "錆", meaning: "Rust, Tarnish" },
    { symbol: "錐", meaning: "Auger, Drill, Awl" },
    { symbol: "錘", meaning: "Weight, Plumb Bob, Sinker" },
    { symbol: "錫", meaning: "Copper, Tin" },
    { symbol: "鍊", meaning: "Smelt Metals, Forge, Refine" },
    { symbol: "鍬", meaning: "Hoe With Long Blade At Acute Angle" },
    { symbol: "鎧", meaning: "Put On Armor, Arm Oneself" },
    { symbol: "鎭", meaning: "Ancient Peace-Preservation Centers" },
    { symbol: "鑄", meaning: "Cast, Mint" },
    { symbol: "閃", meaning: "Flash, Brandish" },
    { symbol: "閏", meaning: "Intercalation, Illegitimate Throne" },
    { symbol: "閤", meaning: "Small Side Gate" },
    { symbol: "阿", meaning: "Africa, Flatter, Fawn Upon" },
    { symbol: "陀", meaning: "Steep" },
    { symbol: "陷", meaning: "Fall Into, Cave In, Fall (Castle)" },
    { symbol: "隈", meaning: "Corner, Nook, Recess" },
    { symbol: "險", meaning: "Inaccessible Place, Impregnable Position, Steep Place" },
    { symbol: "隼", meaning: "Falcon" },
    { symbol: "雀", meaning: "Sparrow" },
    { symbol: "雁", meaning: "Wild Goose" },
    { symbol: "雛", meaning: "Chick, Squab, Duckling" },
    { symbol: "雜", meaning: "Mixed, Blended, Mix" },
    { symbol: "雫", meaning: "Drop, Trickle, Dripping" },
    { symbol: "霞", meaning: "Be Hazy, Grow Dim, Blurred" },
    { symbol: "靖", meaning: "Peaceful" },
    { symbol: "靜", meaning: "Quiet" },
    { symbol: "鞄", meaning: "Suitcase, Bag, Briefcase" },
    { symbol: "鞍", meaning: "Saddle" },
    { symbol: "鞘", meaning: "Sheath, Case, Margin" },
    { symbol: "鞠", meaning: "Ball" },
    { symbol: "鞭", meaning: "Whip, Rod, Counter For Whippings" },
    { symbol: "頁", meaning: "Page, Leaf" },
    { symbol: "頌", meaning: "Eulogy" },
    { symbol: "頗", meaning: "Prejudiced, Exceedingly" },
    { symbol: "顚", meaning: "Top, Peak, Summit" },
    { symbol: "顯", meaning: "Manifest, Display, Evident" },
    { symbol: "颯", meaning: "Sudden, Quick, Sound Of The Wind" },
    { symbol: "飜", meaning: "Flip Over, Upset, Capsize" },
    { symbol: "饗", meaning: "Banquet" },
    { symbol: "馨", meaning: "Fragrant, Balmy, Favourable" },
    { symbol: "馳", meaning: "Run, Gallop, Sail" },
    { symbol: "馴", meaning: "Get Used To, Experienced, Tamed" },
    { symbol: "駈", meaning: "Run, Gallop, Advance" },
    { symbol: "駕", meaning: "Vehicle, Palanquin, Litter" },
    { symbol: "駿", meaning: "A Good Horse, Speed, A Fast Person" },
    { symbol: "騷", meaning: "Harass, Bother, Annoy" },
    { symbol: "驍", meaning: "Strong, Good Horse, Gallant" },
    { symbol: "驗", meaning: "Verification, Effect, Testing" },
    { symbol: "髮", meaning: "Hair" },
    { symbol: "魁", meaning: "Charging Ahead Of Others" },
    { symbol: "魯", meaning: "Foolish, Russia" },
    { symbol: "鮎", meaning: "Freshwater Trout, Smelt" },
    { symbol: "鯉", meaning: "Carp" },
    { symbol: "鯛", meaning: "Sea Bream, Red Snapper" },
    { symbol: "鰯", meaning: "Sardine, (Kokuji)" },
    { symbol: "鱒", meaning: "Salmon Trout" },
    { symbol: "鱗", meaning: "Scales (Fish)" },
    { symbol: "鳩", meaning: "Pigeon, Dove" },
    { symbol: "鳳", meaning: "Male Mythical Bird" },
    { symbol: "鳶", meaning: "Black Kite, Fireman, Hook" },
    { symbol: "鴨", meaning: "Wild Duck, Easy Mark" },
    { symbol: "鴻", meaning: "Large Bird, Wild Goose, Large" },
    { symbol: "鵜", meaning: "Cormorant" },
    { symbol: "鵬", meaning: "Phoenix" },
    { symbol: "鷄", meaning: "Chicken" },
    { symbol: "鷗", meaning: "Seagull, Tern" },
    { symbol: "鷲", meaning: "Eagle" },
    { symbol: "鷹", meaning: "Hawk" },
    { symbol: "鷺", meaning: "Heron" },
    { symbol: "麒", meaning: "Chinese Unicorn, Genius, Giraffe" },
    { symbol: "麟", meaning: "Chinese Unicorn, Genius, Giraffe" },
    { symbol: "麿", meaning: "I, You, (Kokuji)" },
    { symbol: "黃", meaning: "Yellow, Surname" },
    { symbol: "黎", meaning: "Dark, Black, Many" },
    { symbol: "黑", meaning: "Black, Dark, Evil" },
    { symbol: "默", meaning: "Silent, Quiet, Still" },
    { symbol: "黛", meaning: "Blackened Eyebrows" },
    { symbol: "鼎", meaning: "Three Legged Kettle" },
    { symbol: "齊", meaning: "Alike, Equal, Similar" },
    { symbol: "龍", meaning: "Dragon, Imperial" },
    { symbol: "欄", meaning: "Railing, Balustrade, Animal Pan" },
    { symbol: "廊", meaning: "Corridor, Porch, Veranda" },
    { symbol: "朗", meaning: "Clear, Bright, Distinct" },
    { symbol: "虜", meaning: "Capture, Imprison, Seize" },
    { symbol: "類", meaning: "Class, Group, Kind" },
    { symbol: "猪", meaning: "Pig" },
    { symbol: "神", meaning: "Spirit" },
    { symbol: "祥", meaning: "Good Luck" },
    { symbol: "福", meaning: "Happiness" },
    { symbol: "諸", meaning: "Several, Many, Various" },
    { symbol: "都", meaning: "Capital, Metropolis" },
    { symbol: "侮", meaning: "Despise, Contempt" },
    { symbol: "勤", meaning: "Work, Serve" },
    { symbol: "卑", meaning: "Despise, Lowly, Base" },
    { symbol: "墨", meaning: "India Ink, Ink Stick, Mexico" },
    { symbol: "層", meaning: "Stratum, Social Class, Layer" },
    { symbol: "悔", meaning: "Regret, Vexing" },
    { symbol: "梅", meaning: "Plum" },
    { symbol: "煮", meaning: "Boil, Cook" },
    { symbol: "琢", meaning: "Polish" },
    { symbol: "碑", meaning: "Tombstone, Monument" },
    { symbol: "祐", meaning: "Help" },
    { symbol: "祖", meaning: "Ancestor" },
    { symbol: "禍", meaning: "Calamity Misfortune" },
    { symbol: "穀", meaning: "Cereals, Grain" },
    { symbol: "練", meaning: "Knead, Train, Polish" },
    { symbol: "署", meaning: "Signature, Govt Office, Police Station" },
    { symbol: "者", meaning: "Person" },
    { symbol: "臭", meaning: "Odor, Ill-Smelling" },
    { symbol: "賓", meaning: "Guest" },
    { symbol: "贈", meaning: "Presents, Give To" },
    { symbol: "響", meaning: "Echo, Sound, Resound" },
];
